import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const SeoAuditPage = lazyWithRetry(() => import('./pages/SeoAuditPage'))
const SeoAuditDetailPage = lazyWithRetry(() => import('./pages/SeoAuditDetailPage'))

const routes: AppRoute[] = [
  {
    path: 'seo-audit',
    meta: {
      title: 'seoAudit.title',
      require: { minRole: ROLE.ADMIN },
    },
    children: [
      {
        index: true,
        element: SeoAuditPage,
      },
      {
        path: ':id',
        element: SeoAuditDetailPage,
      },
    ],
  },
]

export default routes
